import { i18n, registerI18nBundle } from '@cyberint/common-utils';
import integrationsResources from './trans-resources';

const NAMESPACE = 'integrations';

registerI18nBundle({
  namespace: NAMESPACE,
  en: integrationsResources,
  loaders: {
    es: () => import(/* webpackChunkName: "integrations-i18n-locale-es" */ './trans-locales/es'),
    fil: () => import(/* webpackChunkName: "integrations-i18n-locale-fil" */ './trans-locales/fil'),
    ja: () => import(/* webpackChunkName: "integrations-i18n-locale-ja" */ './trans-locales/ja'),
    th: () => import(/* webpackChunkName: "integrations-i18n-locale-th" */ './trans-locales/th')
  }
});

export const integrationsT = i18n.getFixedT(null, null, NAMESPACE);
